import React from 'react';
import type { ReactElement } from 'react';

import type { ThemeState } from '@atlaskit/tokens/theme-config';

import { mobileAppTheme } from '@confluence/mobile-app-detection/entry-points/theme.ts';
import { useIsMobileApp } from '@confluence/mobile-app-detection/entry-points/MobileAppDetection.ts';

import { useInitializeTheme } from './useInitializeTheme.ts';

export const ThemeContainer = ({ children }: { children: ReactElement }): React.JSX.Element => {
	const { isMobileApp } = useIsMobileApp();

	const initialTheme: Partial<ThemeState> | undefined = isMobileApp ? mobileAppTheme : undefined;

	const isInitialized: boolean = useInitializeTheme(initialTheme);

	if (!isInitialized) {
		return <></>;
	}
	return <>{children}</>;
};
